import { HorizontalTimelineProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: HorizontalTimelineProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as HorizontalTimelineProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      items: [
        { label: 'Instructions completed' },
        { label: 'Domain check' },
        { label: 'Site is live worldwide' },
      ],
    } as HorizontalTimelineProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
